import { Link } from "react-router-dom";
import { Heart, Shield, Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#FF8080]/30 bg-[#1A1414] text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-grain opacity-20 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Shield size={18} className="text-[#FF8080]" />
            <span className="font-display font-black text-lg tracking-tight">
              ARKWEAVER TFX
            </span>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            Guardians of Alkebulan. A cinematic + gamified universe that trains youth
            to navigate the digital world with confidence.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-[0.22em] text-[#FF8080] mb-3">
            Explore
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/gaming" className="hover:text-[#FF8080] transition-colors" data-testid="footer-link-gaming">
                Gaming
              </Link>
            </li>
            <li>
              <Link to="/youtube" className="hover:text-[#FF8080] transition-colors" data-testid="footer-link-youtube">
                YouTube Series
              </Link>
            </li>
            <li>
              <Link to="/kids" className="hover:text-[#FF8080] transition-colors" data-testid="footer-link-kids">
                Kids Interactive
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-[#FF8080] transition-colors" data-testid="footer-link-about">
                About
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-[0.22em] text-[#FF8080] mb-3">
            Powered by
          </h4>
          <div className="flex items-start gap-3">
            <Heart size={20} className="text-[#E60000] fill-[#E60000] mt-1" />
            <div>
              <p className="font-display font-bold text-lg leading-tight">
                The Edutainment Box
              </p>
              <p className="text-sm text-white/60 leading-relaxed mt-1">
                Premium gamified edutainment + cinematic storytelling for grades 6–12.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>
            © {new Date().getFullYear()} Arkweaver TFX — Guardians of Alkebulan. All rights reserved.
          </span>
          <span className="flex items-center gap-2">
            <Sparkles size={12} className="text-[#FF8080]" />
            Mission X — see what isn&apos;t being said.
          </span>
        </div>
      </div>
    </footer>
  );
}
